export enum StationSearchType {
  CITY = 'city',
  COUNTRY = 'country',
  STATE = 'state',
}
